import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, TablePagination, CircularProgress } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp, Sell, UnfoldMore } from "@mui/icons-material";
import moment from "moment/moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  "& svg": {
    position: "relative",
    top: "5px"
  },
  '&:last-child': {
    // paddingRight: 64,
    '& svg': {
      // display: 'none',
      // color: theme.palette.primary.dark
    },
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TableComponent(props) {


  //console.log("pzzzzzzzz", props);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage ? props.rowsPerPage : 10);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // const startIndex = page * rowsPerPage;
  // const endIndex = startIndex + rowsPerPage;
  // const displayedRows = props.rows.slice(startIndex, endIndex);
  // const filteredRows = props.rows.filter((row) =>
  //   row.clientName.includes(props.search)
  // );
  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const searchLowerCase = props?.search?.toLowerCase();
  // const filteredRows = props?.rows?.filter((row) =>
  //   row.clientName.toLowerCase().includes(searchLowerCase) 
  // );
  let filteredRows = props?.rows;

  if (searchLowerCase) {
    filteredRows = props?.rows?.filter((row) =>
      row.clientName.toLowerCase().includes(searchLowerCase)
    );
  }
  const displayedRows = filteredRows.slice(startIndex, endIndex);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {props.columns.map((col, index) =>
                props.sort ?
                  index === 0 ?
                    <StyledTableCell onClick={() => props.handleSort(col.id)}>
                      {props.currentColumn === col.id ? <span style={{ fontWeight: "700" }}>{col.name}</span> : col.name}
                      {props.currentColumn === col.id ? props.direction === "asc" ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" /> : <UnfoldMore fontSize="small" />}
                    </StyledTableCell>
                    :
                    <StyledTableCell align="left" onClick={() => props.handleSort(col.id)}>
                      {props.currentColumn === col.id ? <span style={{ fontWeight: "700" }}>{col.name}</span> : col.name}
                      {props.currentColumn === col.id ? props.direction === "asc" ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" /> : <UnfoldMore fontSize="small" />}
                    </StyledTableCell>
                  :
                  index === 0 ?
                    <StyledTableCell>
                      {col.name}
                    </StyledTableCell>
                    :
                    <StyledTableCell align="left">
                      {col.name}
                    </StyledTableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <StyledTableRow key={Math.random()}>
                  {props.columns.map((col, index) => (
                    <React.Fragment key={index}>
                      {col.id === "image" ? (
                        index === 0 ? (
                          <StyledTableCell component="th" scope="row">
                            <img
                              src={row.image}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell align="left">
                            <img
                              src={row.image}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                              }}
                              alt={row.firstname}
                            />
                          </StyledTableCell>
                        )
                      ) : index === 0 ? (
                        <StyledTableCell component="th" scope="row">
                          {row[col.id]}
                        </StyledTableCell>
                      ) : (
                        (col.id === "clientName" ||
                          col.id === "description" ||
                          col.id === "shortDescription" ||
                          col.id === "text") ? (
                          <StyledTableCell align="left" sx={{ width: "120px" }}>
                            {row[col.id]
                              .substring(0, 25)
                              .concat(row[col.id].length > 25 ? "..." : ' ')
                              .replaceAll(/<[^>]+>/g, '')}
                          </StyledTableCell>
                        ) : col.id === "actions" ? (
                          <StyledTableCell align="left" sx={{ minWidth: "220px" }}>
                            <>
                              <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => props.handleResume(row)}
                              >
                                Resume
                              </Button>
                              {props.keyLoading && props.deletingRow === row.id ? (
                                <CircularProgress
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    marginLeft: "30px",
                                    position: "relative",
                                    top: "10px",
                                  }}
                                />
                              ) : (
                                <Button
                                  color="secondary"
                                  variant="outlined"
                                  onClick={() => props.handleDelete(row)}
                                  sx={{ marginLeft: "10px" }}
                                >
                                  Delete
                                </Button>
                              )}
                            </>
                          </StyledTableCell>
                        ) : (col.id === "added" || col.id === "lastModified") ? (
                          <StyledTableCell align="left">
                            {moment(row[col.id]).format("ddd, MMM Do YYYY, h:mm a")}
                          </StyledTableCell>
                        ) : col.id === "total" ? (
                          <StyledTableCell align="left">
                            {"$" + row[col.id]}
                          </StyledTableCell>
                        ) : col.id === "sales_details" ? (
                          <StyledTableCell align="left">
                            {row[col.id].length}
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell align="left">{row[col.id]}</StyledTableCell>
                        )
                      )}
                    </React.Fragment>
                  ))}
                </StyledTableRow>
              ))}
          </TableBody>

        </Table>
      </TableContainer>
      {props.footer !== false && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 50]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </Paper>
  );
}
